/*
 * Component grid reviews
 */

// Settings to the carousel init
function getSliderSettings() {
  return {
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 300,
          infinite: false,
          dots: true,
        },
      },
    ],
  };
}

jQuery( function( $ ) {
  const bodyWidth = $('body').width();
  if (bodyWidth < 992) {
    $('.grid-reviews-wrapper')
      .slick(getSliderSettings());
  }
});
